var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._b({ref:"imageRef",attrs:{"src":this.source},on:{"load":_vm.handleLoad,"error":_vm.handleError}},'img',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }